!function (n, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t();else if ("function" == typeof define && define.amd) define([], t);else {
    var r = t();

    for (var e in r) {
      ("object" == typeof exports ? exports : n)[e] = r[e];
    }
  }
}(this, function () {
  return function (n) {
    function t(e) {
      if (r[e]) return r[e].exports;
      var u = r[e] = {
        i: e,
        l: !1,
        exports: {}
      };
      return n[e].call(u.exports, u, u.exports, t), u.l = !0, u.exports;
    }

    var r = {};
    return t.m = n, t.c = r, t.i = function (n) {
      return n;
    }, t.d = function (n, r, e) {
      t.o(n, r) || Object.defineProperty(n, r, {
        configurable: !1,
        enumerable: !0,
        get: e
      });
    }, t.n = function (n) {
      var r = n && n.__esModule ? function () {
        return n.default;
      } : function () {
        return n;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (n, t) {
      return Object.prototype.hasOwnProperty.call(n, t);
    }, t.p = "", t(t.s = 4);
  }([function (n, t, r) {
    n.exports = r(6);
  }, function (n, t, r) {
    "use strict";

    function e(n, t) {
      return o(n) || f(n, t) || u();
    }

    function u() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }

    function f(n, t) {
      var r = [],
          e = !0,
          u = !1,
          f = void 0;

      try {
        for (var o, i = n[Symbol.iterator](); !(e = (o = i.next()).done) && (r.push(o.value), !t || r.length !== t); e = !0) {
          ;
        }
      } catch (n) {
        u = !0, f = n;
      } finally {
        try {
          e || null == i.return || i.return();
        } finally {
          if (u) throw f;
        }
      }

      return r;
    }

    function o(n) {
      if (Array.isArray(n)) return n;
    }

    function i(n) {
      return "return args[+ (".concat(n, ")];");
    }

    function a(n) {
      var t = F[n];
      return t || (t = new Function("n", "args", i(n)), F[n] = t), t;
    }

    function c(n) {
      var t = n["plural-forms"] || n["Plural-Forms"];
      if (!t) throw new Error('po. data should include "language" or "plural-form" header for ngettext');
      var r = O.exec(t)[1];
      return ";" === r[r.length - 1] && (r = r.slice(0, -1)), r;
    }

    function s(n) {
      var t = [];

      for (var r in n) {
        n.hasOwnProperty(r) && t.push(r);
      }

      return t;
    }

    function l(n, t) {
      return n.replace(z, function (n) {
        return "${".concat(t[_(n)], "}");
      });
    }

    function g(n) {
      var t = {},
          r = n.match(z);
      if (!r) return null;

      for (var e = 0; e < r.length; e++) {
        t[_(r[e])] = e;
      }

      return t;
    }

    function d(n) {
      var t = g(n.msgid);
      if (!t) return n;
      var r = l(n.msgid, t),
          e = {
        msgid: r
      };
      n.msgid_plural && (e.msgid_plural = l(n.msgid_plural, t)), e.msgstr = [];

      for (var u = n.msgstr, f = 0; f < u.length; f++) {
        e.msgstr.push(l(u[f], t));
      }

      return e.comments = n.comments, e;
    }

    function h(n) {
      for (var t = {}, r = s(n.translations), e = 0; e < r.length; e++) {
        for (var u = r[e], f = n.translations[u], o = {}, i = s(f), a = 0; a < i.length; a++) {
          var c = i[a],
              l = d(f[c]);
          o[l.msgid] = l;
        }

        t[u] = o;
      }

      return n.translations = t, n;
    }

    function v(n, t) {
      var r = g(n);
      return r ? [l(n, r), t.map(function (n) {
        return l(n, r);
      })] : [n, t];
    }

    function p(n) {
      for (var t = {
        headers: n.headers
      }, r = {}, u = s(n.contexts), f = 0; f < u.length; f++) {
        for (var o = u[f], i = {}, a = s(n.contexts[o]), c = 0; c < a.length; c++) {
          var l = a[c],
              g = n.contexts[o][l],
              d = v(l, g),
              h = e(d, 2),
              p = h[0],
              m = h[1];
          i[p] = m;
        }

        r[o] = i;
      }

      return t.contexts = r, t;
    }

    function m(n) {
      return "string" != typeof n ? n : -1 === n.indexOf("\n") ? n : y()(n);
    }

    function L(n) {
      var t = n.getCurrentLocaleHeaders(),
          e = t.language || t.Language;
      return e ? r.i(w.getPluralFunc)(e) : a(c(t));
    }

    r.d(t, "c", function () {
      return b;
    }), r.d(t, "d", function () {
      return D;
    }), r.d(t, "a", function () {
      return P;
    }), r.d(t, "e", function () {
      return A;
    }), t.g = h, t.h = p, t.b = m, t.f = L;

    var x = r(5),
        y = r.n(x),
        w = r(0),
        b = (r.n(w), function (n, t) {
      for (var r = [], e = t.length, u = n.length, f = 0; f < u; f++) {
        var o = f < e ? "${".concat(f, "}") : "";
        r.push(n[f] + o);
      }

      return r.join("");
    }),
        _ = function _(n) {
      return n.replace(/\s/g, "");
    },
        j = {},
        k = function k(n) {
      return new RegExp("\\$\\{(?:[\\s]+?|\\s?)".concat(n, "(?:[\\s]+?|\\s?)}"));
    },
        C = function (n) {
      return function (t) {
        return j[t] ? j[t] : (j[t] = n(t), j[t]);
      };
    }(k),
        D = function D(n, t) {
      return t.reduce(function (n, t, r) {
        return n.replace(C(r), t);
      }, n);
    },
        P = function P(n, t) {
      return n.reduce(function (n, r, e) {
        return n + r + (void 0 !== t[e] ? t[e] : "");
      }, "");
    },
        A = function A(n, t) {
      return n.reduce(function (n, r, e) {
        return void 0 !== t[e] ? n.concat(r, t[e]) : n.concat(r);
      }, []);
    },
        F = {},
        O = /\splural ?=?([\s\S]*);?/,
        z = /\$\{\s*([.\w+\[\]])*\s*\}/g;
  }, function (n, t, r) {
    "use strict";

    var e = r(0);
    r.n(e);
  }, function (n, t, r) {
    "use strict";

    function e() {
      var n = {
        locales: {},
        currentLocales: [],
        currentLocale: "en",
        dedent: !0,
        defaultLang: "en"
      };
      this.addLocale = function (t, e) {
        if (e.translations) e = r.i(u.g)(e);else {
          if (!e.contexts) throw new Error("Invalid locale data format");
          e = r.i(u.h)(e);
        }
        n.locales[t] = e;
      }, this.setCurrentLocale = function (t) {
        n.currentLocale = t;
      }, this.setDedent = function (t) {
        n.dedent = t;
      }, this.setCurrentLocales = function (t) {
        n.currentLocales = t;
      }, this.getAvailLocales = function () {
        return n.locales;
      }, this.getCurrentLocales = function () {
        return n.currentLocales;
      }, this.getCurrentLocale = function () {
        return n.currentLocale;
      }, this.isDedent = function () {
        return n.dedent;
      }, this.setDefaultLang = function (t) {
        n.defaultLang = t;
      }, this.getDefaultPluralFn = function () {
        return r.i(f.getPluralFunc)(n.defaultLang);
      }, this.getDefaultPluralFormsCount = function () {
        return r.i(f.getNPlurals)(n.defaultLang);
      }, this.getCurrentLocaleHeaders = function () {
        return n.locales[n.currentLocale].headers;
      };
    }

    t.a = e;
    var u = r(1),
        f = (r(2), r(0));
    r.n(f);
  }, function (n, t, r) {
    "use strict";

    function e(n) {
      this.getContext = function () {
        return n;
      };
    }

    function u(n) {
      return n && n.comments && "fuzzy" === n.comments.flag;
    }

    function f(n) {
      if (!n) return !1;

      for (var t = 0; t < n.length; t++) {
        if (!n[t].length) return !1;
      }

      return !0;
    }

    function o(n) {
      if (n && n.reduce) {
        for (var t = arguments.length, e = new Array(t > 1 ? t - 1 : 0), u = 1; u < t; u++) {
          e[u - 1] = arguments[u];
        }

        var f = new String(r.i(a.a)(n, e));
        return f._strs = n, f._exprs = e, f;
      }

      return n;
    }

    function i() {
      function n(n) {
        x.setDefaultLang(n);
      }

      function t(n) {
        x.setCurrentLocales(n);
      }

      function o(n) {
        x.setDedent(Boolean(n));
      }

      function i(n) {
        x.setCurrentLocale(n);
      }

      function d(n, t) {
        x.addLocale(n, t);
      }

      function h(n) {
        var t = n;

        if (n && n.reduce) {
          for (var e = arguments.length, u = new Array(e > 1 ? e - 1 : 0), f = 1; f < e; f++) {
            u[f - 1] = arguments[f];
          }

          var o = y(r.i(a.c)(n, u)),
              i = s(this),
              c = b(o, i);
          t = c ? r.i(a.d)(c[0], u) : r.i(a.a)(n, u);
        }

        return y(t);
      }

      function v(n) {
        for (var t = arguments.length, e = new Array(t > 1 ? t - 1 : 0), u = 1; u < t; u++) {
          e[u - 1] = arguments[u];
        }

        if (n && n.reduce) {
          var f = y(r.i(a.c)(n, e)),
              o = s(this),
              i = b(f, o);
          if (!i) return r.i(a.e)(n, e);
          return i[0].split(l).map(function (n) {
            var t = n.match(g);
            return t ? e[+t[1]] : n;
          });
        }

        return n;
      }

      function p() {
        for (var n = arguments.length, t = new Array(n), e = 0; e < n; e++) {
          t[e] = arguments[e];
        }

        var u = y(r.i(a.c)(t[0]._strs, t[0]._exprs)),
            f = t[t.length - 1],
            o = t.slice(1, -1);
        o.unshift(t[0].toString());
        var i = b(u, s(this));

        if (i) {
          var c = r.i(a.f)(x);
          return y(r.i(a.d)(c(f, i), t[0]._exprs));
        }

        var l = x.getDefaultPluralFn();
        return y(l(f, o));
      }

      function m(n) {
        var t = s(this),
            r = b(n, t);
        return r ? r[0] : n;
      }

      function L(n) {
        var t = new e(n);
        return {
          t: h.bind(t),
          jt: v.bind(t),
          gettext: m.bind(t),
          ngettext: p.bind(t)
        };
      }

      var x = new c.a(),
          y = function y(n) {
        return x.isDedent() ? r.i(a.b)(n) : n;
      },
          w = function w(n, t, r) {
        var e = x.getAvailLocales(),
            o = e[n];
        if (!o) return null;

        if (o.translations) {
          var i = o.translations[r] || o.translations[""],
              a = i && i[t];
          if (a && !u(a) && f(a.msgstr)) return a.msgstr;
        }

        if (o.contexts) {
          var c = o.contexts[r] || o.contexts[""],
              s = c && c[t];
          if (s && f(s)) return s;
        }

        return null;
      },
          b = function b(n, t) {
        var r = x.getCurrentLocales();
        if (r.length) for (var e = 0; e < r.length; e++) {
          var u = w(r[e], n, t);
          if (u) return x.setCurrentLocale(r[e]), u;
        }
        return w(x.getCurrentLocale(), n, t);
      };

      return {
        _: m,
        addLocale: d,
        c: L,
        gettext: m,
        jt: v,
        ngettext: p,
        setDedent: o,
        setDefaultLang: n,
        t: h,
        useLocale: i,
        useLocales: t
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.msgid = o, t.TTag = i, r.d(t, "_", function () {
      return h;
    }), r.d(t, "addLocale", function () {
      return v;
    }), r.d(t, "c", function () {
      return p;
    }), r.d(t, "gettext", function () {
      return m;
    }), r.d(t, "jt", function () {
      return L;
    }), r.d(t, "ngettext", function () {
      return x;
    }), r.d(t, "setDedent", function () {
      return y;
    }), r.d(t, "setDefaultLang", function () {
      return w;
    }), r.d(t, "t", function () {
      return b;
    }), r.d(t, "useLocale", function () {
      return _;
    }), r.d(t, "useLocales", function () {
      return j;
    });

    var a = r(1),
        c = (r(2), r(3)),
        s = function s(n) {
      return n instanceof e ? n.getContext() : "";
    },
        l = /(\${\s*\d+\s*})/g,
        g = /\${\s*(\d+)\s*}/,
        d = new i(),
        h = d._,
        v = d.addLocale,
        p = d.c,
        m = d.gettext,
        L = d.jt,
        x = d.ngettext,
        y = d.setDedent,
        w = d.setDefaultLang,
        b = d.t,
        _ = d.useLocale,
        j = d.useLocales;
  }, function (n, t, r) {
    "use strict";

    function e(n) {
      var t = void 0;
      t = "string" == typeof n ? [n] : n.raw;

      for (var r = "", e = 0; e < t.length; e++) {
        r += t[e].replace(/\\\n[ \t]*/g, "").replace(/\\`/g, "`"), e < (arguments.length <= 1 ? 0 : arguments.length - 1) && (r += arguments.length <= e + 1 ? void 0 : arguments[e + 1]);
      }

      var u = r.split("\n"),
          f = null;
      return u.forEach(function (n) {
        var t = n.match(/^(\s+)\S+/);

        if (t) {
          var r = t[1].length;
          f = f ? Math.min(f, r) : r;
        }
      }), null !== f && (r = u.map(function (n) {
        return " " === n[0] ? n.slice(f) : n;
      }).join("\n")), r = r.trim(), r.replace(/\\n/g, "\n");
    }

    n.exports = e;
  }, function (n, t, r) {
    "use strict";

    function e(n, t) {
      if (t[n]) return t[n];
      var r = n.match(l);
      if (!r) throw new Error("Can't find lang or lcale with code " + n);
      return t[r[1]];
    }

    function u(n) {
      return n > 1;
    }

    function f(n) {
      return 1 !== n;
    }

    function o(n) {
      return 0;
    }

    function i(n) {
      return e(n, g).n;
    }

    function a(n) {
      if (d[n]) return d[n];

      var t = e(n, g),
          r = function r(n, _r) {
        return _r[+t.f(n)];
      };

      return d[n] = r, r;
    }

    function c(n) {
      try {
        return e(n, g), !0;
      } catch (n) {
        return !1;
      }
    }

    function s() {
      return Object.keys(g);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var l = /(\w+)[-_].*/,
        g = {
      ach: {
        n: 2,
        f: u
      },
      af: {
        n: 2,
        f: f
      },
      ak: {
        n: 2,
        f: u
      },
      am: {
        n: 2,
        f: u
      },
      an: {
        n: 2,
        f: f
      },
      ar: {
        n: 6,
        f: function f(n) {
          return 0 === n ? 0 : 1 === n ? 1 : 2 === n ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
        }
      },
      arn: {
        n: 2,
        f: u
      },
      ast: {
        n: 2,
        f: f
      },
      ay: {
        n: 1,
        f: o
      },
      az: {
        n: 2,
        f: f
      },
      be: {
        n: 3,
        f: function f(n) {
          return n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
        }
      },
      bg: {
        n: 2,
        f: f
      },
      bn: {
        n: 2,
        f: f
      },
      bo: {
        n: 1,
        f: o
      },
      br: {
        n: 2,
        f: u
      },
      brx: {
        n: 2,
        f: f
      },
      bs: {
        n: 3,
        f: function f(n) {
          return n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
        }
      },
      ca: {
        n: 2,
        f: f
      },
      cgg: {
        n: 1,
        f: o
      },
      cs: {
        n: 3,
        f: function f(n) {
          return 1 === n ? 0 : n >= 2 && n <= 4 ? 1 : 2;
        }
      },
      csb: {
        n: 3,
        f: function f(n) {
          return 1 === n ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
        }
      },
      cy: {
        n: 4,
        f: function f(n) {
          return 1 === n ? 0 : 2 === n ? 1 : 8 !== n && 11 !== n ? 2 : 3;
        }
      },
      da: {
        n: 2,
        f: f
      },
      de: {
        n: 2,
        f: f
      },
      doi: {
        n: 2,
        f: f
      },
      dz: {
        n: 1,
        f: o
      },
      el: {
        n: 2,
        f: f
      },
      en: {
        n: 2,
        f: f
      },
      eo: {
        n: 2,
        f: f
      },
      es: {
        n: 2,
        f: f
      },
      et: {
        n: 2,
        f: f
      },
      eu: {
        n: 2,
        f: f
      },
      fa: {
        n: 1,
        f: o
      },
      ff: {
        n: 2,
        f: f
      },
      fi: {
        n: 2,
        f: f
      },
      fil: {
        n: 2,
        f: u
      },
      fo: {
        n: 2,
        f: f
      },
      fr: {
        n: 2,
        f: u
      },
      fur: {
        n: 2,
        f: f
      },
      fy: {
        n: 2,
        f: f
      },
      ga: {
        n: 5,
        f: function f(n) {
          return 1 === n ? 0 : 2 === n ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4;
        }
      },
      gd: {
        n: 4,
        f: function f(n) {
          return 1 === n || 11 === n ? 0 : 2 === n || 12 === n ? 1 : n > 2 && n < 20 ? 2 : 3;
        }
      },
      gl: {
        n: 2,
        f: f
      },
      gu: {
        n: 2,
        f: f
      },
      gun: {
        n: 2,
        f: u
      },
      ha: {
        n: 2,
        f: f
      },
      he: {
        n: 2,
        f: f
      },
      hi: {
        n: 2,
        f: f
      },
      hne: {
        n: 2,
        f: f
      },
      hr: {
        n: 3,
        f: function f(n) {
          return n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
        }
      },
      hu: {
        n: 2,
        f: f
      },
      hy: {
        n: 2,
        f: f
      },
      id: {
        n: 1,
        f: o
      },
      is: {
        n: 2,
        f: function f(n) {
          return n % 10 != 1 || n % 100 == 11;
        }
      },
      it: {
        n: 2,
        f: f
      },
      ja: {
        n: 1,
        f: o
      },
      jbo: {
        n: 1,
        f: o
      },
      jv: {
        n: 2,
        f: function f(n) {
          return 0 !== n;
        }
      },
      ka: {
        n: 1,
        f: o
      },
      kk: {
        n: 1,
        f: o
      },
      km: {
        n: 1,
        f: o
      },
      kn: {
        n: 2,
        f: f
      },
      ko: {
        n: 1,
        f: o
      },
      ku: {
        n: 2,
        f: f
      },
      kw: {
        n: 4,
        f: function f(n) {
          return 1 === n ? 0 : 2 === n ? 1 : 3 === n ? 2 : 3;
        }
      },
      ky: {
        n: 1,
        f: o
      },
      lb: {
        n: 2,
        f: f
      },
      ln: {
        n: 2,
        f: u
      },
      lo: {
        n: 1,
        f: o
      },
      lt: {
        n: 3,
        f: function f(n) {
          return n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
        }
      },
      lv: {
        n: 3,
        f: function f(n) {
          return n % 10 == 1 && n % 100 != 11 ? 0 : 0 !== n ? 1 : 2;
        }
      },
      mai: {
        n: 2,
        f: f
      },
      mfe: {
        n: 2,
        f: u
      },
      mg: {
        n: 2,
        f: u
      },
      mi: {
        n: 2,
        f: u
      },
      mk: {
        n: 2,
        f: function f(n) {
          return 1 === n || n % 10 == 1 ? 0 : 1;
        }
      },
      ml: {
        n: 2,
        f: f
      },
      mn: {
        n: 2,
        f: f
      },
      mni: {
        n: 2,
        f: f
      },
      mnk: {
        n: 3,
        f: function f(n) {
          return 0 === n ? 0 : 1 === n ? 1 : 2;
        }
      },
      mr: {
        n: 2,
        f: f
      },
      ms: {
        n: 1,
        f: o
      },
      mt: {
        n: 4,
        f: function f(n) {
          return 1 === n ? 0 : 0 === n || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3;
        }
      },
      my: {
        n: 1,
        f: o
      },
      nah: {
        n: 2,
        f: f
      },
      nap: {
        n: 2,
        f: f
      },
      nb: {
        n: 2,
        f: f
      },
      ne: {
        n: 2,
        f: f
      },
      nl: {
        n: 2,
        f: f
      },
      nn: {
        n: 2,
        f: f
      },
      no: {
        n: 2,
        f: f
      },
      nso: {
        n: 2,
        f: f
      },
      oc: {
        n: 2,
        f: u
      },
      or: {
        n: 2,
        f: f
      },
      pa: {
        n: 2,
        f: f
      },
      pap: {
        n: 2,
        f: f
      },
      pl: {
        n: 3,
        f: function f(n) {
          return 1 === n ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
        }
      },
      pms: {
        n: 2,
        f: f
      },
      ps: {
        n: 2,
        f: f
      },
      pt: {
        n: 2,
        f: f
      },
      rm: {
        n: 2,
        f: f
      },
      ro: {
        n: 3,
        f: function f(n) {
          return 1 === n ? 0 : 0 === n || n % 100 > 0 && n % 100 < 20 ? 1 : 2;
        }
      },
      ru: {
        n: 3,
        f: function f(n) {
          return n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
        }
      },
      rw: {
        n: 2,
        f: f
      },
      sah: {
        n: 1,
        f: o
      },
      sat: {
        n: 2,
        f: f
      },
      sco: {
        n: 2,
        f: f
      },
      sd: {
        n: 2,
        f: f
      },
      se: {
        n: 2,
        f: f
      },
      si: {
        n: 2,
        f: f
      },
      sk: {
        n: 3,
        f: function f(n) {
          return 1 === n ? 0 : n >= 2 && n <= 4 ? 1 : 2;
        }
      },
      sl: {
        n: 4,
        f: function f(n) {
          return n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0;
        }
      },
      so: {
        n: 2,
        f: f
      },
      son: {
        n: 2,
        f: f
      },
      sq: {
        n: 2,
        f: f
      },
      sr: {
        n: 3,
        f: function f(n) {
          return n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
        }
      },
      su: {
        n: 1,
        f: o
      },
      sv: {
        n: 2,
        f: f
      },
      sw: {
        n: 2,
        f: f
      },
      ta: {
        n: 2,
        f: f
      },
      te: {
        n: 2,
        f: f
      },
      tg: {
        n: 2,
        f: u
      },
      th: {
        n: 1,
        f: o
      },
      ti: {
        n: 2,
        f: u
      },
      tk: {
        n: 2,
        f: f
      },
      tr: {
        n: 2,
        f: u
      },
      tt: {
        n: 1,
        f: o
      },
      ug: {
        n: 1,
        f: o
      },
      uk: {
        n: 3,
        f: function f(n) {
          return n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
        }
      },
      ur: {
        n: 2,
        f: f
      },
      uz: {
        n: 2,
        f: u
      },
      vi: {
        n: 1,
        f: o
      },
      wa: {
        n: 2,
        f: u
      },
      wo: {
        n: 1,
        f: o
      },
      yo: {
        n: 2,
        f: f
      },
      zh: {
        n: 1,
        f: o
      }
    },
        d = {};
    t.getNPlurals = i, t.getPluralFunc = a, t.hasLang = c, t.getAvailLangs = s;
  }]);
});